<template>
  <ul class="status-bar inline clearfix">
    <li class="left item1">
      <span v-if="type < 2" :class="{ active: type === 1 }">{{ type === 1 ? '...' : '1' }}</span>
      <span v-else class="iconfont icon-d"></span><br>
      <span :class="{ active: type === 1 }">验证身份</span>
    </li>
    <li class="left item2">
      <span v-if="type < 3" :class="{ active: type === 2 }">{{ type === 2 ? '...' : '2' }}</span>
      <span v-else class="iconfont icon-d"></span><br>
      <span :class="{ active: type === 2 }">设置新{{ isChangePhone ? '手机号' : '密码' }}</span>
    </li>
    <li class="left item3">
      <span v-if="type === 3" class="iconfont icon-d"></span>
      <span v-else>3</span>
      <br>
      <span :class="{ active: type === 3 }">完成</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'component-status-bar',
  props: {
    type: {
      type: Number,
      require: true
    },
    isChangePhone: Boolean
  }
}
</script>

<style lang="less" scoped>
.status-bar {
  li {
    position: relative;
    &:not(:last-child) { 
      margin-right: 160px;
      &::after {
        content: ''; position: absolute; left: 36px; top: 10px; width: 200px; height: 10px; background-color: #dcdcdc;
      }
    }
    &.item2 span {
      position: relative; z-index: 1;
    }
    &:nth-child(2)::after {
      left: 40px;
    }
    span {
      font-size: 12px; color: #999; display: inline-block; cursor: default;
      &:first-child {
        width: 20px; height: 20px; line-height: 20px; background-color: #f2f2f2; color: #999999; border-radius: 50%; border: 5px solid #dcdcdc; box-sizing: content-box;
      }
      &:first-child.active {
        background-color: #24c278; color: #ffffff; line-height: 14px;
      }
      &:last-child.active {
        color: #666666;
      }
      &.icon-d {
        background-color: #24c278; color: #ffffff;
      }
    }
  }
}
</style>
